// extracted by mini-css-extract-plugin
module.exports = {"nonScroll":"style_nonScroll__255f9","element":"style_element__326pa"};